var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCxaSym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1",
    width: 91.805,
    height: 78.803,
    viewBox: "0 0 24.29 20.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-122.766 -96.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path11",
    fill: "#e82074",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    d: "m131.596 96.309-.07.002-4.184.3a1.4 1.4 0 0 0-.875.387l-.008.008-2.908 2.84a1.4 1.4 0 0 0-.426.888l-.354 3.954-.002.017c-.02.272.04.557.188.813l.002.002 1.517 2.595c.069.117.142.201.164.227l.024.025 2.383 2.545.052.053c-.03-.028-.005.007.114.098l2.955 2.338 3.812 3.404.01.008c.26.226.573.346.92.346.343 0 .67-.13.912-.334l.022-.02 3.806-3.404 2.971-2.35-.08.057c.163-.105.189-.152.213-.176l.021-.022 2.371-2.53q.122-.127.2-.264l.006-.01 1.51-2.584c.142-.243.218-.534.187-.844l.002.01-.354-3.953v-.004c-.03-.33-.175-.64-.42-.877l-2.914-2.848-.011-.01a1.44 1.44 0 0 0-.836-.383l-.027-.002-4.19-.3-.07-.002h-.03c-.347 0-.668.126-.917.343l-2.368 2.057-2.369-2.053h-.002a1.4 1.4 0 0 0-.916-.345l-.004-.002zm-.178 2.015 2.842 2.465a1 1 0 0 0 1.31-.002l2.838-2.463 3.715.266 2.602 2.543.316 3.539-1.39 2.38-2.307 2.46-2.957 2.338-.047.039-3.428 3.066-3.433-3.066-.047-.04-2.961-2.341-2.301-2.46-1.389-2.374.317-3.543 2.601-2.541zm-2.977 11.16c-.002 0 .038.031.01.006l.01.01z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCxaSym);
export default __webpack_public_path__ + "static/media/CXA_sym.d64736ff4787aaa9a98469682215ebd1.svg";
export { ForwardRef as ReactComponent };